import '../styles/components/PageLoader.css';
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'abl-initial-loader-seen';
const MIN_DISPLAY_MS = 1400;
const LOGO_SRC = '/img/samplelogo.jpeg';

function PageLoader() {
  const [isActive, setIsActive] = useState(() => !sessionStorage.getItem(STORAGE_KEY));
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (!isActive) return undefined;

    document.body.classList.add('page-loader-active');

    let cancelled = false;
    const startedAt = Date.now();

    const finish = () => {
      const elapsed = Date.now() - startedAt;
      const delay = Math.max(0, MIN_DISPLAY_MS - elapsed);

      window.setTimeout(() => {
        if (cancelled) return;
        sessionStorage.setItem(STORAGE_KEY, '1');
        setIsExiting(true);
      }, delay);
    };

    if (document.readyState === 'complete') {
      finish();
    } else {
      window.addEventListener('load', finish, { once: true });
    }

    return () => {
      cancelled = true;
    };
  }, [isActive]);

  useEffect(() => {
    if (!isExiting) return undefined;

    const timer = window.setTimeout(() => {
      document.body.classList.remove('page-loader-active');
      setIsActive(false);
    }, 450);

    return () => window.clearTimeout(timer);
  }, [isExiting]);

  if (!isActive) return null;

  return (
    <div
      className={`page-loader${isExiting ? ' page-loader--exit' : ''}`}
      role="status"
      aria-live="polite"
      aria-label="Loading ABL Construction"
    >
      <div className="page-loader-inner">
        <img className="page-loader-logo" src={LOGO_SRC} alt="ABL Construction Limited" />
        <div className="page-loader-bar" aria-hidden="true">
          <span className="page-loader-bar-fill" />
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
